<script setup lang="ts">
/**
 * Work in flight, visible from every page: up to three jobs with a hairline progress each.
 * Percent first, then the bar; indeterminate = the light sweep. Hidden when nothing runs.
 */
import ProgressCell from '~/components/ui/ProgressCell.vue'

interface QueueItem { id: string; label: string; status: string; percent: number | null; note?: string }
defineProps<{ items: QueueItem[] }>()
</script>

<template>
  <div v-if="items.length" class="mx-1.5 mb-1.5 rounded-md border border-sidebar-border bg-card p-2 pb-1.5">
    <div class="mb-1.5 flex items-center justify-between">
      <span class="text-[length:var(--type-meta)] font-semibold text-sidebar-foreground/45">Queue</span>
      <span class="num text-[length:var(--type-fine)] text-muted-foreground">{{ items.length }} active</span>
    </div>
    <div class="flex flex-col gap-1.5">
      <div v-for="it in items" :key="it.id" class="flex flex-col gap-0.5">
        <div class="flex items-center justify-between gap-2 text-[length:var(--type-meta)]">
          <span class="truncate text-sidebar-foreground">{{ it.label }}</span>
          <span v-if="it.note" class="num shrink-0 text-muted-foreground">{{ it.note }}</span>
        </div>
        <ProgressCell :percent="it.percent" :status="it.status" :bar-width="0" grow />
      </div>
    </div>
  </div>
</template>
